<!-- appDefaultAvatarXxxxIfError is not triggered without src, so we have else -->

<ng-container *ngIf="isCompany; else customer">
  <img *ngIf="src; else noCompanyAvatar" [appJwtSrc]="src" appDefaultAvatarCompanyIfError />
  <ng-template #noCompanyAvatar>
    <img src="assets/img/default-avatar-company.png" />
  </ng-template>
</ng-container>

<ng-template #customer>
  <img *ngIf="src; else noCustomerAvatar" [appJwtSrc]="src" appDefaultAvatarCustomerIfError />
  <ng-template #noCustomerAvatar>
    <img src="assets/img/default-avatar-customer.png" />
  </ng-template>
</ng-template>
